document.addEventListener('DOMContentLoaded', () => {
  function searchAndRedirect() {
    let searchField = document.querySelector("[data-type='job-id-search']");
    if (searchField) {
      let jobId = searchField.value;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.open("GET", location.protocol + '//' + location.hostname + '/joburi.json?uid=' + jobId, true);
      xmlhttp.addEventListener('load', function(event) {
        if (xmlhttp.status === 200) {
          let response = JSON.parse(xmlhttp.responseText);
          let url = response.url;
          if (url) {
            window.location.href = url;
            return;
          }
          // no matching job-id
          alert('Keine passende Job-ID gefunden.');
        }
      });
      xmlhttp.send();
    }
  }

  let searchField = document.querySelector("[data-type='job-id-search']");
  if (searchField) {
    searchField.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') {
        searchAndRedirect();
      }
    });
    let searchButton = document.querySelector("[data-type='job-id-search-btn']");
    if (searchButton) {
      searchButton.addEventListener('click', searchAndRedirect);
    }
  }
});
